import { render, staticRenderFns } from "./MyDashboard.vue?vue&type=template&id=27380ad6&scoped=true&"
import script from "./MyDashboard.vue?vue&type=script&lang=ts&"
export * from "./MyDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./MyDashboard.vue?vue&type=style&index=0&id=27380ad6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27380ad6",
  null
  
)

/* custom blocks */
import block0 from "./MyDashboard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VProgressCircular,VRow})
